import * as React from 'react';
import * as styles from './styles.css';

import { ArticleParagraph2, ArticleHeading4, Responsive, useDeviceType } from '@cian/ui-kit';

import { Stars } from '../packages/Stars';
import { AgentType, RgrCertificate } from '../RgrCertificate';
import { ETabs } from '../../types/redux/tabs';
import { getCardUrl } from '../../utils/openCard/getCardUrl';
import { useSelector } from 'react-redux';
import { getCurrentTab } from '../../selectors/tabs';
import { IRealtorSchema } from '../../repositories/agent-catalog-search/entities/realtor/RealtorSchema';

export interface IReview {
  name: string;
  reviewText: string;
}
export interface IRealtorCardProps {
  previewImg: React.ReactNode;
  age: string;
  agencyName: string;
  agentId: number;
  hasRgrParticipation: IRealtorSchema['hasRgrParticipation'];
  review?: IReview | null;
  name: string;
  offersCount: string;
  rate?: number | null;
  reviewsCount: string;
  onClick(): void;
  levelNumber?: number | null;
  levelName?: string | null;
  superAgentBadge: React.ReactNode;
}

export function RealtorCard({
  previewImg,
  age,
  agencyName,
  agentId,
  review,
  name,
  offersCount,
  rate,
  reviewsCount,
  onClick,
  hasRgrParticipation,
  superAgentBadge,
}: IRealtorCardProps) {
  const currentTab = useSelector(getCurrentTab);
  const deviceType = useDeviceType();
  const url = getCardUrl(currentTab as ETabs, agentId);

  const handleNameClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (deviceType !== 'desktop') {
      window.open(url, '_self');
    } else {
      window.open(url);
    }
  };

  return (
    <div className={styles['container']} onClick={onClick}>
      <div className={styles['one-column']}>
        <div className={styles['img']}>{previewImg}</div>
        <div className={styles['text-info']}>
          <div>
            <div className={styles['name']}>
              <a href={url} onClick={handleNameClick}>
                {name}
              </a>
              {hasRgrParticipation && <RgrCertificate type={AgentType.Realtor} />}
            </div>
          </div>
          {superAgentBadge && <div className={styles['badge']}>{superAgentBadge}</div>}
          <div>
            <ArticleParagraph2 color="black_60">{agencyName}</ArticleParagraph2>
          </div>
          <div>
            <ArticleParagraph2 color="black_60">{age}</ArticleParagraph2>
          </div>
        </div>
      </div>
      <div className={styles['two-column']}>
        <div className={styles['left']}>
          {rate && (
            <div className={styles['rating']}>
              <ArticleHeading4>{(rate * 5).toFixed(1)}</ArticleHeading4>
              <div className={styles['stars']}>
                <Stars uniqueKey={`${agentId}`} value={rate} />
              </div>
            </div>
          )}
          <div className={styles['reviews']}>
            <ArticleParagraph2 color="black_60">{reviewsCount}</ArticleParagraph2>
          </div>
          {review && (
            <Responsive desktop>
              <div className={styles['comment']}>
                <ArticleParagraph2 color="black_60">{review.name}: </ArticleParagraph2>
                <ArticleParagraph2>{review.reviewText}</ArticleParagraph2>
              </div>
            </Responsive>
          )}
        </div>
        <div className={styles['right']}>
          <div>
            <ArticleHeading4>{offersCount}</ArticleHeading4>
          </div>
          <div>
            <ArticleParagraph2 color="black_60">в работе</ArticleParagraph2>
          </div>
        </div>
      </div>
    </div>
  );
}
